module.exports = __webpack_public_path__ + "static/media/faq-icon.51c03a5d.svg";